module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/kF1yPj/tc-custom/9781488090608.jpg?1726574163311",
      "alt": "This image is the cover for the book His New Amish Family, The Amish Bachelors"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("His New Amish Family, The Amish Bachelors\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Her home—and heart—on the line…  in the heartwarming conclusion to The Amish Bachelors series  Widow Clara Fisher’s late uncle promised his farm to her—but she can’t find the documents to prove it! Desperate to stop her Englisch cousin from selling it, she seeks the help of auctioneer Paul Bowman. Paul’s always been a wandering spirit, but will sweet, stubborn Clara and her children suddenly fill his empty life with family and love?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Patricia Davids\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("USA Today best-selling author Patricia Davids was born in Kansas. After forty years as an NICU nurse, Pat switched careers to become an inspirational writer. She now enjoys laid back life on a Kansas farm, spending time with her family and playing with her dog Sugar, who thinks fetch should be a twenty-four hour a day game. When not throwing a ball, Pat is happily dreaming up new stories where love and faith conquer all. Contact her at pat@patriciadavids.com. ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0